import React, { useEffect } from 'react';
import { FormControlLabel, RadioGroup, Radio } from "@material-ui/core";
import { makeStyles } from '@material-ui/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import NumberFormat from 'react-number-format';
import '../../../styles/loanofficer-realestateagent.scss';

export default function DownPaymentEquity(props) {
    const resetAllInputField = () => {
        if (props.values.is_equity_required === "false") {
            props.values.equity_unlock_requested  = '';
		}
    };

    function StyledRadio(props) {
        const useStyles = makeStyles({
            root: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            }
        })
        const classes = useStyles();
        return (
            <Radio
                className={classes.root}
                disableripple="true"
                color="default"
                checkedIcon={<CheckCircleIcon className="checkedIcon" />}
                icon={<RadioButtonUncheckedIcon />}
                {...props}
            />
        );
    }

    return (
        <div>
            <h4 className="form-content-heading m-0">Do you need to access equity in your existing home for a down payment on the new home?</h4>
            <div className="py-2">
                <RadioGroup
                    row name="is_equity_required"
                    style={{width: '150px'}}
                    value={props.values.is_equity_required}
                    onClick={resetAllInputField}
                    onChange={props.handleChange}
                >
                    <div>
                        <FormControlLabel value="true" control={<StyledRadio />} label="Yes" />
                    </div>
                    <div>
                        <FormControlLabel value="false" control={<StyledRadio />} label="No" />
                    </div>
                </RadioGroup>
                {props.values.is_equity_required === "true" &&
					<>
					    <div className="w-res-50 py-2 px-3">
					        <div className="col-12">
						        <h6 style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-semibold"}:{}}>How much equity do you need?</h6>
						        <NumberFormat
                                    className="amount-field"
                                    thousandSeparator={','}
                                    decimalSeparator={'.'}
                                    autoComplete='off'
                                    prefix="$"
                                    allowNegative={false}
                                    decimalScale={2}
                                    maxLength="10"
                                    id="equity_unlock_requested"
                                    inputMode="numeric"
                                    name="equity_unlock_requested"
                                    value={props.values.equity_unlock_requested}
                                    onChange={props.handleChange}
                                    onBlur={props.handleBlur}
                                    allowEmptyFormatting
                                />
					        </div>
				        </div>
                    </> 
                }
                {props.validateDisplay11 === true ?
                    props.errors.equity_unlock_requested !== '' ?
                        <div className="error-msg">{props.errors.equity_unlock_requested}</div> : ''
                    : ''}
            </div>
        </div>
    )
}